/**
 * Shared display constants for KB documents.
 * Lives in its own file so KBDocumentRow.tsx remains a single-export
 * component file (react-refresh/only-export-components).
 */
import type { DocType } from '@/hooks/useKBDocuments';

export const DOC_TYPE_LABELS: Record<DocType, string> = {
  legislation: 'Legislation',
  regulation: 'Regulation',
  directive: 'Directive',
  guideline: 'Guideline',
  internal_policy: 'Internal Policy',
};

export const DOC_TYPE_CLASSES: Record<DocType, string> = {
  legislation: 'bg-purple-100 text-purple-800 border-purple-200 dark:bg-purple-900/30 dark:text-purple-300',
  regulation: 'bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-900/30 dark:text-blue-300',
  directive: 'bg-teal-100 text-teal-800 border-teal-200 dark:bg-teal-900/30 dark:text-teal-300',
  guideline: 'bg-green-100 text-green-800 border-green-200 dark:bg-green-900/30 dark:text-green-300',
  internal_policy: 'bg-gray-100 text-gray-700 border-gray-200 dark:bg-gray-800/40 dark:text-gray-300',
};

export function formatKbDate(iso: string | null): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}
